import { ApiResponse } from '@core/interface/api-response.interface';
import { PageableResponse } from '@core/interface/pageable.interface';
import { RefId } from '@core/interface/ref-id.interface';
import { Observable } from 'rxjs';
import { CreateManagementScheduleRequestDto } from '../dtos/create-management-schedule.request.dto';
import { ListManagementScheduleRequestDto } from '../dtos/list-management-schedule.request.dto';
import { ManagementScheduleResponseDto } from '../dtos/management-schedule.response.dto';
import { UpdateManagementScheduleRequestDto } from '../dtos/update-management-schedule.request.dto';
import { UpdateStateManagementScheduleRequestDto } from '../dtos/update-state-management-schedule.request.dto';

export abstract class ManagementScheduleRepository {
  abstract list(
    request: ListManagementScheduleRequestDto,
  ): Observable<ApiResponse<PageableResponse<ManagementScheduleResponseDto>>>;

  abstract show(request: RefId): Observable<ApiResponse<ManagementScheduleResponseDto>>;

  abstract create(
    request: CreateManagementScheduleRequestDto,
  ): Observable<ApiResponse<ManagementScheduleResponseDto>>;

  abstract update(
    request: UpdateManagementScheduleRequestDto,
  ): Observable<ApiResponse<ManagementScheduleResponseDto>>;

  abstract updateState(
    request: UpdateStateManagementScheduleRequestDto,
  ): Observable<ApiResponse<ManagementScheduleResponseDto>>;

  abstract delete(request: RefId): Observable<ApiResponse<void>>;
}
